import z from 'zod';

export const partSchema = z.object({
  id: z.number(),
  paymentPercent: z.number(),
  discountPercent: z.number(),
  months: z.number()
});

export const discountSchema = z.object({
  id: z.number(),
  name: z.string(),
  parts: z.array(partSchema),
  createdDate: z.string(),
  createdBy: z.string()
});

export type Discount = z.infer<typeof discountSchema>;
export type Part = z.infer<typeof partSchema>;
